export default __webpack_public_path__ + "static/media/acer.36262051.png";